import moment from "moment";

export const convertDurationToExpireDate = (startDate, duration) => {
  let expireDate = moment(startDate);
  switch (duration) {
    case "1 Month":
      expireDate = expireDate.add(1, "month");
      break;
    case "3 Months":
      expireDate = expireDate.add(3, "month");
      break;
    case "6 Months":
      expireDate = expireDate.add(6, "month");
      break;
    case "12 Months":
      expireDate = expireDate.add(12, "month");
      break;
    case "2 Years":
      expireDate = expireDate.add(2, "year");
      break;
    case "3 Years":
      expireDate = expireDate.add(3, "year");
      break;
    default:
      break;
  }

  return expireDate;
};
